import { ensureExhaustive } from "@dhau/lang-extras";
import type { Bitmap } from "../bitmap/types.ts";

type SuccessPosteriseImageResult<TSuccess extends object> = {
	readonly type: "success";
} & TSuccess;

type PosteriseImageResult<TSuccess extends object> =
	| SuccessPosteriseImageResult<TSuccess>
	| { readonly type: "unavailable"; readonly message: string };

type BitmapPosteriseImageResult = PosteriseImageResult<{
	readonly image: Bitmap;
}>;

type SuccessBitmapPosteriseImageResult = Extract<
	BitmapPosteriseImageResult,
	{ readonly type: "success" }
>;

type UrlPosteriseImageResult = PosteriseImageResult<{ readonly url: string }>;

async function asyncMapSuccessPosteriseImageResult<
	TFrom extends object,
	TTo extends object,
>(
	result: PosteriseImageResult<TFrom>,
	mapper: (success: SuccessPosteriseImageResult<TFrom>) => Promise<TTo>,
): Promise<PosteriseImageResult<TTo>> {
	switch (result.type) {
		case "success":
			return {
				type: "success",
				...(await mapper(result)),
			};
		case "unavailable":
			return result;
		default:
			ensureExhaustive(result);
	}
}

export { asyncMapSuccessPosteriseImageResult };
export type {
	SuccessBitmapPosteriseImageResult,
	BitmapPosteriseImageResult,
	UrlPosteriseImageResult,
};
